export default __webpack_public_path__ + "static/media/our-services-social-care-children’s-learning-disability -despites-01.0594ef6f.jpg";